import { format } from 'date-fns'

class Focus {
    constructor(props){
        let updatedProps = props || {}
        this.focusID = updatedProps.focusID
        this.userID = updatedProps.userID;
        this.date = updatedProps.date && format(new Date(updatedProps.date), 'LLL d Y') || format(new Date(), 'LLL d Y');
        this.items = updatedProps.items || [];
        this.notes = updatedProps.notes
    }
}

export default Focus
